import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Button } from '../components/ui/Button';
import { ColumnFilter } from '../components/ui/ColumnFilter';
const initialTickets = [{
  id: 1,
  codice: 'N7G2UFDK',
  titolo: 'Richiesta info rendicontazione',
  richiedente: 'Mario Rossi',
  stato: 'Aperto',
  priorita: 'Alta',
  tipologia: 'Informazioni',
  argomento: 'Rendicontazione',
  bando: 'Bando 1 - Nuove Opere',
  assegnatoA: null,
  data: '15/05/2025'
}, {
  id: 2,
  codice: 'V2YCA7S7',
  titolo: 'Problema caricamento allegati',
  richiedente: 'Luigi Verdi',
  stato: 'In Lavorazione',
  priorita: 'Media',
  tipologia: 'Assistenza Tecnica',
  argomento: 'Piattaforma',
  bando: 'Bando 3 - Professionalizzazione',
  assegnatoA: 'Admin',
  data: '14/05/2025'
}, {
  id: 3,
  codice: 'WE1BB8OS',
  titolo: 'Chiarimento art. 4',
  richiedente: 'Giulia Bianchi',
  stato: 'Chiuso',
  priorita: 'Bassa',
  tipologia: 'Informazioni',
  argomento: 'Bando',
  bando: 'Bando 2 - Scuole',
  assegnatoA: 'Admin',
  data: '10/05/2025'
}, {
  id: 4,
  codice: 'BTXGWUY9',
  titolo: 'Errore login SPID',
  richiedente: 'Paolo Neri',
  stato: 'Aperto',
  priorita: 'Alta',
  tipologia: 'Assistenza Tecnica',
  argomento: 'Accesso',
  bando: '-',
  assegnatoA: null,
  data: '16/05/2025'
}, {
  id: 5,
  codice: '5WOECLTF',
  titolo: 'Proroga scadenza',
  richiedente: 'Anna Gialli',
  stato: 'In Lavorazione',
  priorita: 'Media',
  tipologia: 'Informazioni',
  argomento: 'Scadenze',
  bando: 'Bando 1 - Nuove Opere',
  assegnatoA: 'Admin',
  data: '15/05/2025'
}, {
  id: 6,
  codice: 'X9M4PLQ1',
  titolo: 'Modifica dati anagrafici',
  richiedente: 'Marco Bruni',
  stato: 'Aperto',
  priorita: 'Bassa',
  tipologia: 'Assistenza Tecnica',
  argomento: 'Profilo',
  bando: '-',
  assegnatoA: null,
  data: '16/05/2025'
}, {
  id: 7,
  codice: 'K3J8HGF2',
  titolo: 'CUP non valido',
  richiedente: 'Elena Viola',
  stato: 'Chiuso',
  priorita: 'Alta',
  tipologia: 'Informazioni',
  argomento: 'Rendicontazione',
  bando: 'Bando 4 - Live',
  assegnatoA: 'Admin',
  data: '05/05/2025'
}, {
  id: 8,
  codice: 'P7N2BVC4',
  titolo: 'Richiesta subentro',
  richiedente: 'Roberto Blu',
  stato: 'In Lavorazione',
  priorita: 'Media',
  tipologia: 'Informazioni',
  argomento: 'Gestione Progetto',
  bando: 'Bando 1 - Nuove Opere',
  assegnatoA: 'Altro Admin',
  data: '12/05/2025'
}, {
  id: 9,
  codice: 'L4R9TYU3',
  titolo: 'Richiesta accesso documentazione',
  richiedente: 'Sara Conti',
  stato: 'Aperto',
  priorita: 'Media',
  tipologia: 'Informazioni',
  argomento: 'Documentazione',
  bando: 'Bando 1 - Nuove Opere',
  assegnatoA: null,
  data: '17/05/2025'
}, {
  id: 10,
  codice: 'M8K2QWE5',
  titolo: 'Errore nel calcolo budget',
  richiedente: 'Franco Neri',
  stato: 'Chiuso',
  priorita: 'Alta',
  tipologia: 'Assistenza Tecnica',
  argomento: 'Budget',
  bando: 'Bando 3 - Professionalizzazione',
  assegnatoA: 'Admin',
  data: '08/05/2025'
}];
const StatoBadge = ({
  stato
}: {
  stato: string;
}) => {
  const styles: Record<string, React.CSSProperties> = {
    Aperto: {
      backgroundColor: '#e3f2fd',
      color: '#1565c0',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    'In Lavorazione': {
      backgroundColor: '#fff3e0',
      color: '#e65100',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    Chiuso: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    }
  };
  return <span style={styles[stato] || styles['Aperto']} data-id="element-1165">{stato}</span>;
};
const PrioritaBadge = ({
  priorita
}: {
  priorita: string;
}) => {
  const styles: Record<string, React.CSSProperties> = {
    Alta: {
      backgroundColor: '#fce4ec',
      color: '#c62828',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    Media: {
      backgroundColor: '#fff3e0',
      color: '#e65100',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    Bassa: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      borderRadius: '12px',
      fontSize: '12px',
      padding: '2px 10px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      display: 'inline-block',
      whiteSpace: 'nowrap'
    }
  };
  return <span style={styles[priorita] || styles['Media']} data-id="element-1166">{priorita}</span>;
};
const CARD_STYLE: React.CSSProperties = {
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  boxShadow: 'none'
};
const selectStyle: React.CSSProperties = {
  height: '40px',
  padding: '0 32px 0 12px',
  border: '1px solid #E4E4E4',
  borderRadius: '9999px',
  fontSize: '14px',
  fontFamily: 'Roboto, sans-serif',
  color: '#2A3A54',
  backgroundColor: 'white',
  cursor: 'pointer',
  outline: 'none',
  appearance: 'none' as const,
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' viewBox='0 0 12 7'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2380858E' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center'
};
interface TabView {
  id: string;
  name: string;
  statoFilter: string;
  prioritaFilter: string;
  assegnazioneFilter: string;
  bandoFilter: string;
  columnFilters: {
    codice: string;
    titolo: string;
    richiedente: string;
    stato: string;
    priorita: string;
    tipologia: string;
    bando: string;
  };
  searchQuery: string;
  rowsPerPage: number;
  currentPage: number;
}
const createDefaultTab = (id: string, name: string, isAssegnatiAMe: boolean): TabView => ({
  id,
  name,
  statoFilter: 'tutti',
  prioritaFilter: 'tutti',
  assegnazioneFilter: isAssegnatiAMe ? 'assegnati-a-me' : 'tutti',
  bandoFilter: 'tutti',
  columnFilters: {
    codice: '',
    titolo: '',
    richiedente: '',
    stato: '',
    priorita: '',
    tipologia: '',
    bando: ''
  },
  searchQuery: '',
  rowsPerPage: 10,
  currentPage: 1
});
export function GestioneTicket() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAssegnatiAMe = location.pathname.includes('assegnati-a-te');
  const [tabs, setTabs] = useState<TabView[]>([createDefaultTab('tab-1', isAssegnatiAMe ? 'Assegnati a me' : 'Tutti', isAssegnatiAMe)]);
  const [activeTabId, setActiveTabId] = useState<string>('tab-1');
  const [editingTabId, setEditingTabId] = useState<string | null>(null);
  const [editTabName, setEditTabName] = useState('');
  const editInputRef = useRef<HTMLInputElement>(null);
  const activeTab = tabs.find(t => t.id === activeTabId) || tabs[0];
  const updateActiveTab = (updates: Partial<TabView>) => {
    setTabs(prev => prev.map(tab => tab.id === activeTabId ? {
      ...tab,
      ...updates
    } : tab));
  };
  const handleAddTab = () => {
    const newId = `tab-${Date.now()}`;
    const newName = `Vista ${tabs.length + 1}`;
    const newTab = createDefaultTab(newId, newName, false);
    setTabs([...tabs, newTab]);
    setActiveTabId(newId);
  };
  const handleRemoveTab = (e: React.MouseEvent, idToRemove: string) => {
    e.stopPropagation();
    if (tabs.length <= 1) return;
    const newTabs = tabs.filter(t => t.id !== idToRemove);
    setTabs(newTabs);
    if (activeTabId === idToRemove) {
      setActiveTabId(newTabs[newTabs.length - 1].id);
    }
  };
  const handleDoubleClickTab = (tab: TabView) => {
    setEditingTabId(tab.id);
    setEditTabName(tab.name);
  };
  const handleSaveTabName = () => {
    if (editingTabId && editTabName.trim()) {
      setTabs(prev => prev.map(tab => tab.id === editingTabId ? {
        ...tab,
        name: editTabName.trim()
      } : tab));
    }
    setEditingTabId(null);
  };
  const handleKeyDownTabName = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveTabName();
    } else if (e.key === 'Escape') {
      setEditingTabId(null);
    }
  };
  useEffect(() => {
    if (editingTabId && editInputRef.current) {
      editInputRef.current.focus();
      editInputRef.current.select();
    }
  }, [editingTabId]);
  // Sync route pre-filter when route changes
  useEffect(() => {
    if (isAssegnatiAMe) {
      setTabs([createDefaultTab('tab-1', 'Assegnati a me', true)]);
      setActiveTabId('tab-1');
    } else {
      setTabs([createDefaultTab('tab-1', 'Tutti', false)]);
      setActiveTabId('tab-1');
    }
  }, [location.pathname]);
  const {
    statoFilter,
    prioritaFilter,
    assegnazioneFilter,
    bandoFilter,
    columnFilters,
    searchQuery,
    rowsPerPage,
    currentPage
  } = activeTab;
  // Filter logic
  const filteredData = initialTickets.filter(item => {
    // Panel filters
    if (statoFilter !== 'tutti' && item.stato !== statoFilter) return false;
    if (prioritaFilter !== 'tutti' && item.priorita !== prioritaFilter) return false;
    if (assegnazioneFilter === 'non-assegnati' && item.assegnatoA !== null) return false;
    if (assegnazioneFilter === 'assegnati-a-me' && item.assegnatoA !== 'Admin') return false;
    if (bandoFilter !== 'tutti' && item.bando !== bandoFilter) return false;
    // Search
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      if (!item.codice.toLowerCase().includes(q) && !item.titolo.toLowerCase().includes(q) && !item.richiedente.toLowerCase().includes(q)) return false;
    }
    // Column filters
    if (columnFilters.codice && !item.codice.toLowerCase().includes(columnFilters.codice.toLowerCase())) return false;
    if (columnFilters.titolo && !item.titolo.toLowerCase().includes(columnFilters.titolo.toLowerCase())) return false;
    if (columnFilters.richiedente && !item.richiedente.toLowerCase().includes(columnFilters.richiedente.toLowerCase())) return false;
    if (columnFilters.stato && !item.stato.toLowerCase().includes(columnFilters.stato.toLowerCase())) return false;
    if (columnFilters.priorita && !item.priorita.toLowerCase().includes(columnFilters.priorita.toLowerCase())) return false;
    if (columnFilters.tipologia && !item.tipologia.toLowerCase().includes(columnFilters.tipologia.toLowerCase())) return false;
    if (columnFilters.bando && !item.bando.toLowerCase().includes(columnFilters.bando.toLowerCase())) return false;
    return true;
  });
  // Active filters count
  const activeFiltersCount = (statoFilter !== 'tutti' ? 1 : 0) + (prioritaFilter !== 'tutti' ? 1 : 0) + (assegnazioneFilter !== 'tutti' ? 1 : 0) + (bandoFilter !== 'tutti' ? 1 : 0);
  const resetFilters = () => {
    updateActiveTab({
      statoFilter: 'tutti',
      prioritaFilter: 'tutti',
      assegnazioneFilter: isAssegnatiAMe ? 'assegnati-a-me' : 'tutti',
      bandoFilter: 'tutti',
      currentPage: 1
    });
  };
  // Pagination
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / rowsPerPage) || 1;
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const currentData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const handleColumnFilterChange = (key: keyof typeof columnFilters, value: string) => {
    updateActiveTab({
      columnFilters: {
        ...columnFilters,
        [key]: value
      },
      currentPage: 1
    });
  };
  // Build filter label
  const buildFilterLabel = () => {
    const parts: string[] = [];
    if (statoFilter !== 'tutti') parts.push(statoFilter);
    if (prioritaFilter !== 'tutti') parts.push('Priorità: ' + prioritaFilter);
    if (assegnazioneFilter === 'non-assegnati') parts.push('Non assegnati');
    if (assegnazioneFilter === 'assegnati-a-me') parts.push('Assegnati a me');
    if (bandoFilter !== 'tutti') parts.push(bandoFilter);
    return parts.length > 0 ? parts.join(' · ') : '';
  };
  const filterLabel = buildFilterLabel();
  return <div className="space-y-6 pb-12" style={{
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-1167">
      {/* Page Header */}
      <div className="bg-white" style={{
      ...CARD_STYLE,
      padding: '24px 32px'
    }} data-id="element-1168">
        <div className="flex items-center justify-between" data-id="element-1169">
          <h1 style={{
          fontSize: '24px',
          fontWeight: 400,
          color: '#293B54',
          fontFamily: 'Roboto, sans-serif',
          margin: 0
        }} data-id="element-1170">
            Gestione Ticket - {activeTab.name}
            {filterLabel && <span style={{
            color: '#80858E',
            fontSize: '20px',
            marginLeft: '8px'
          }} data-id="element-1171">
                ({filterLabel})
              </span>}
          </h1>
          <Button variant="primary" className="flex items-center gap-2" data-id="element-1172">
            <Icon icon="tabler:plus" fontSize={16} data-id="element-1173" />
            Nuovo ticket
          </Button>
        </div>
      </div>

      {/* Tab Bar Workspace */}
      <div className="bg-white flex items-center overflow-x-auto" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '0 32px'
    }} data-id="element-1174">
        <div className="flex items-end gap-2 pt-2" data-id="element-1175">
          {tabs.map(tab => {
          const isActive = tab.id === activeTabId;
          const isEditing = tab.id === editingTabId;
          return <div key={tab.id} onClick={() => setActiveTabId(tab.id)} onDoubleClick={() => handleDoubleClickTab(tab)} className="group flex items-center gap-2 relative transition-colors" style={{
            padding: '14px 16px',
            paddingBottom: '12px',
            cursor: 'pointer',
            color: isActive ? '#293B54' : '#80858E',
            borderBottom: isActive ? '2px solid #2A97DF' : '2px solid transparent',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '15px',
            fontWeight: isActive ? 500 : 400,
            marginBottom: '-1px'
          }} data-id="element-1176">
                {isEditing ? <input ref={editInputRef} type="text" value={editTabName} onChange={e => setEditTabName(e.target.value)} onBlur={handleSaveTabName} onKeyDown={handleKeyDownTabName} style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontSize: '15px',
              fontWeight: 500,
              color: '#293B54',
              border: 'none',
              outline: 'none',
              background: 'transparent',
              width: `${Math.max(editTabName.length * 9, 60)}px`,
              padding: 0
            }} data-id="element-1177" /> : <span className="select-none whitespace-nowrap" data-id="element-1178">
                    {tab.name}
                  </span>}

                {tabs.length > 1 && !isEditing && <button onClick={e => handleRemoveTab(e, tab.id)} className={`flex items-center justify-center rounded-full p-0.5 transition-colors ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} style={{
              color: '#AAAAAA',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer'
            }} onMouseEnter={e => e.currentTarget.style.color = '#EA5455'} onMouseLeave={e => e.currentTarget.style.color = '#AAAAAA'} aria-label="Chiudi vista" data-id="element-1179">
                    <Icon icon="tabler:x" fontSize={14} data-id="element-1180" />
                  </button>}
              </div>;
        })}

          <button onClick={handleAddTab} className="flex items-center gap-1 transition-colors mb-2 ml-2" style={{
          padding: '8px 12px',
          color: '#AAAAAA',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          borderRadius: '4px'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F5F5F5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-1181">
            <Icon icon="tabler:plus" fontSize={14} data-id="element-1182" />
            Nuova vista
          </button>
        </div>
      </div>

      {/* Filter Panel */}
      <div className="bg-white" style={CARD_STYLE} data-id="element-1183">
        {/* Filter Header */}
        <div className="flex items-center justify-between" style={{
        padding: '14px 32px',
        borderBottom: '1px solid #E4E4E4'
      }} data-id="element-1184">
          <div className="flex items-center" style={{
          gap: '8px'
        }} data-id="element-1185">
            <Icon icon="tabler:filter" fontSize={18} style={{
            color: '#293B54'
          }} data-id="element-1186" />
            <span style={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#293B54',
            fontFamily: 'Roboto Condensed, sans-serif',
            letterSpacing: '0.3px'
          }} data-id="element-1187">
              FILTRI
            </span>
            {activeFiltersCount > 0 && <span style={{
            backgroundColor: '#2A97DF',
            color: 'white',
            fontSize: '11px',
            fontWeight: 500,
            fontFamily: 'Roboto Condensed, sans-serif',
            padding: '2px 8px',
            borderRadius: '10px',
            lineHeight: '16px'
          }} data-id="element-1188">
                {activeFiltersCount}
              </span>}
          </div>
          {activeFiltersCount > 0 && <button type="button" onClick={resetFilters} style={{
          background: 'none',
          border: 'none',
          color: '#EA5455',
          fontSize: '13px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 500,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 8px',
          borderRadius: '9999px'
        }} className="hover:bg-red-50 transition-colors" data-id="element-1189">
              <Icon icon="tabler:x" fontSize={14} data-id="element-1190" />
              Resetta tutto
            </button>}
        </div>

        {/* Filter Controls */}
        <div className="flex items-start flex-wrap" style={{
        padding: '20px 32px',
        gap: '24px'
      }} data-id="element-1191">
          {/* Stato */}
          <div className="flex flex-col" style={{
          gap: '6px'
        }} data-id="element-1192">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-1193">
              Stato
            </label>
            <select value={statoFilter} onChange={e => updateActiveTab({
            statoFilter: e.target.value,
            currentPage: 1
          })} style={{
            ...selectStyle,
            minWidth: '200px',
            borderColor: statoFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4'
          }} data-id="element-1194">
              <option value="tutti" data-id="element-1195">Tutti gli stati</option>
              <option value="Aperto" data-id="element-1196">Aperto</option>
              <option value="In Lavorazione" data-id="element-1197">In Lavorazione</option>
              <option value="Chiuso" data-id="element-1198">Chiuso</option>
            </select>
          </div>

          {/* Divider */}
          <div style={{
          width: '1px',
          height: '58px',
          backgroundColor: '#E4E4E4',
          flexShrink: 0
        }} data-id="element-1199" />

          {/* Priorità */}
          <div className="flex flex-col" style={{
          gap: '6px'
        }} data-id="element-1200">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-1201">
              Priorità
            </label>
            <select value={prioritaFilter} onChange={e => updateActiveTab({
            prioritaFilter: e.target.value,
            currentPage: 1
          })} style={{
            ...selectStyle,
            minWidth: '180px',
            borderColor: prioritaFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4'
          }} data-id="element-1202">
              <option value="tutti" data-id="element-1203">Tutte</option>
              <option value="Alta" data-id="element-1204">Alta</option>
              <option value="Media" data-id="element-1205">Media</option>
              <option value="Bassa" data-id="element-1206">Bassa</option>
            </select>
          </div>

          {/* Divider */}
          <div style={{
          width: '1px',
          height: '58px',
          backgroundColor: '#E4E4E4',
          flexShrink: 0
        }} data-id="element-1207" />

          {/* Assegnazione */}
          <div className="flex flex-col" style={{
          gap: '6px'
        }} data-id="element-1208">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-1209">
              Assegnazione
            </label>
            <select value={assegnazioneFilter} onChange={e => updateActiveTab({
            assegnazioneFilter: e.target.value,
            currentPage: 1
          })} style={{
            ...selectStyle,
            minWidth: '200px',
            borderColor: assegnazioneFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4'
          }} data-id="element-1210">
              <option value="tutti" data-id="element-1211">Tutti</option>
              <option value="non-assegnati" data-id="element-1212">Non assegnati</option>
              <option value="assegnati-a-me" data-id="element-1213">Assegnati a me</option>
            </select>
          </div>

          {/* Divider */}
          <div style={{
          width: '1px',
          height: '58px',
          backgroundColor: '#E4E4E4',
          flexShrink: 0
        }} data-id="element-1214" />

          {/* Bando */}
          <div className="flex flex-col" style={{
          gap: '6px'
        }} data-id="element-1215">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-1216">
              Bando
            </label>
            <select value={bandoFilter} onChange={e => updateActiveTab({
            bandoFilter: e.target.value,
            currentPage: 1
          })} style={{
            ...selectStyle,
            minWidth: '260px',
            borderColor: bandoFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4'
          }} data-id="element-1217">
              <option value="tutti" data-id="element-1218">Tutti i bandi</option>
              <option value="Bando 1 - Nuove Opere" data-id="element-1219">
                Bando 1 - Nuove Opere
              </option>
              <option value="Bando 2 - Scuole" data-id="element-1220">Bando 2 - Scuole</option>
              <option value="Bando 3 - Professionalizzazione" data-id="element-1221">
                Bando 3 - Professionalizzazione
              </option>
              <option value="Bando 4 - Live" data-id="element-1222">Bando 4 - Live</option>
            </select>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-white overflow-hidden" style={CARD_STYLE} data-id="element-1223">
        {/* Search Bar */}
        <div className="flex items-center" style={{
        padding: '16px 20px',
        borderBottom: '1px solid #E4E4E4',
        gap: '0'
      }} data-id="element-1224">
          <div className="relative" style={{
          width: '280px'
        }} data-id="element-1225">
            <Icon icon="tabler:search" fontSize={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{
            color: '#AAAAAA'
          }} data-id="element-1226" />
            <input type="text" placeholder="Cerca nei ticket..." value={searchQuery} onChange={e => updateActiveTab({
            searchQuery: e.target.value
          })} className="w-full" style={{
            height: '36px',
            paddingLeft: '36px',
            paddingRight: '12px',
            border: '1px solid #E4E4E4',
            borderRadius: '8px 0 0 8px',
            fontSize: '13px',
            fontFamily: 'Roboto, sans-serif',
            color: '#444444',
            outline: 'none'
          }} data-id="element-1227" />
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-1228">
          <table className="w-full" style={{
          borderCollapse: 'collapse',
          minWidth: '1100px'
        }} data-id="element-1229">
            <thead data-id="element-1230">
              <tr style={{
              backgroundColor: 'white',
              borderBottom: '2px solid #E4E4E4'
            }} data-id="element-1231">
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '100px'
              }} data-id="element-1232">
                  <ColumnFilter label="Codice" value={columnFilters.codice} onChange={v => handleColumnFilterChange('codice', v)} data-id="element-1233" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '180px'
              }} data-id="element-1234">
                  <ColumnFilter label="Titolo" value={columnFilters.titolo} onChange={v => handleColumnFilterChange('titolo', v)} data-id="element-1235" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '140px'
              }} data-id="element-1236">
                  <ColumnFilter label="Richiedente" value={columnFilters.richiedente} onChange={v => handleColumnFilterChange('richiedente', v)} data-id="element-1237" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '110px'
              }} data-id="element-1238">
                  <ColumnFilter label="Stato" value={columnFilters.stato} onChange={v => handleColumnFilterChange('stato', v)} data-id="element-1239" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '100px'
              }} data-id="element-1240">
                  <ColumnFilter label="Priorità" value={columnFilters.priorita} onChange={v => handleColumnFilterChange('priorita', v)} data-id="element-1241" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '140px'
              }} data-id="element-1242">
                  <ColumnFilter label="Tipologia" value={columnFilters.tipologia} onChange={v => handleColumnFilterChange('tipologia', v)} data-id="element-1243" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '160px'
              }} data-id="element-1244">
                  <ColumnFilter label="Bando" value={columnFilters.bando} onChange={v => handleColumnFilterChange('bando', v)} data-id="element-1245" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '100px'
              }} data-id="element-1246">
                  Data
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '80px',
                position: 'sticky',
                right: 0,
                backgroundColor: 'white',
                zIndex: 2,
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.08)'
              }} data-id="element-1247">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1248">
              {currentData.length > 0 ? currentData.map(row => <tr key={row.id} onClick={() => navigate(`/ticket/${row.id}`)} style={{
              backgroundColor: 'white',
              borderBottom: '1px solid #E4E4E4',
              cursor: 'pointer'
            }} className="hover:bg-blue-50 transition-colors" data-id="element-1249">
                    <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 500
              }} data-id="element-1250">
                      {row.codice}
                    </td>
                    <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                maxWidth: '180px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }} title={row.titolo} data-id="element-1251">
                      {row.titolo}
                    </td>
                    <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1252">
                      {row.richiedente}
                    </td>
                    <td style={{
                padding: '14px 16px'
              }} data-id="element-1253">
                      <StatoBadge stato={row.stato} data-id="element-1254" />
                    </td>
                    <td style={{
                padding: '14px 16px'
              }} data-id="element-1255">
                      <PrioritaBadge priorita={row.priorita} data-id="element-1256" />
                    </td>
                    <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1257">
                      {row.tipologia}
                    </td>
                    <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                color: '#444444',
                fontFamily: 'Roboto, sans-serif',
                maxWidth: '160px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }} title={row.bando} data-id="element-1258">
                      {row.bando}
                    </td>
                    <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1259">
                      {row.data}
                    </td>
                    <td style={{
                padding: '14px 16px',
                position: 'sticky',
                right: 0,
                backgroundColor: 'inherit',
                zIndex: 1,
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.08)'
              }} data-id="element-1260">
                      <div className="flex items-center gap-1" data-id="element-1261">
                        <button onClick={e => {
                    e.stopPropagation();
                    navigate(`/ticket/${row.id}`);
                  }} className="p-1.5 hover:bg-gray-100 transition-colors" style={{
                    color: '#AAAAAA',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    borderRadius: '4px'
                  }} title="Visualizza" data-id="element-1262">
                          <Icon icon="tabler:eye" fontSize={18} data-id="element-1263" />
                        </button>
                      </div>
                    </td>
                  </tr>) : <tr data-id="element-1264">
                  <td colSpan={9} style={{
                padding: '32px 16px',
                textAlign: 'center',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px'
              }} data-id="element-1265">
                    Nessun ticket trovato con i filtri correnti.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-end gap-4" style={{
        padding: '16px 24px',
        borderTop: '1px solid #E4E4E4'
      }} data-id="element-1266">
          <div className="flex items-center gap-2" data-id="element-1267">
            <span style={{
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            color: '#444444'
          }} data-id="element-1268">
              Righe per pagina:
            </span>
            <select value={rowsPerPage} onChange={e => updateActiveTab({
            rowsPerPage: Number(e.target.value),
            currentPage: 1
          })} style={{
            padding: '4px 8px',
            border: 'none',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            color: '#444444',
            cursor: 'pointer',
            outline: 'none'
          }} data-id="element-1269">
              <option value={10} data-id="element-1270">10</option>
              <option value={25} data-id="element-1271">25</option>
              <option value={50} data-id="element-1272">50</option>
            </select>
          </div>
          <span style={{
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
          color: '#444444'
        }} data-id="element-1273">
            {startItem}-{endItem} di {totalItems}
          </span>
          <div className="flex items-center gap-1" data-id="element-1274">
            <button type="button" onClick={() => updateActiveTab({
            currentPage: Math.max(1, currentPage - 1)
          })} disabled={currentPage === 1} className="p-1 rounded hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            color: '#444444'
          }} data-id="element-1275">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-1276" />
            </button>
            <button type="button" onClick={() => updateActiveTab({
            currentPage: Math.min(totalPages, currentPage + 1)
          })} disabled={currentPage === totalPages || totalItems === 0} className="p-1 rounded hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            color: '#444444'
          }} data-id="element-1277">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-1278" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}